// extracted by mini-css-extract-plugin
export default {"inputHeading":"Branches-inputHeading-2DI","list":"Branches-list-3Gd","ctaContainer":"Branches-ctaContainer-QrI"};